import styled from 'styled-components';
var ImageStyles = styled.img.withConfig({
  displayName: "Imagestyles__ImageStyles",
  componentId: "pantheon__yhiedo-0"
})(["height:500px;width:500px;background-size:auto;object-fit:cover;"]);
export { ImageStyles };